module.exports = __webpack_public_path__ + "img/video-accommodation.3e0bb99a.svg";